import Dashboard from './components/Dashboard.vue'
import DashboardEmpty from './components/modules/dashboard/DashboardEmpty.vue'
import DashboardIndex from './components/modules/dashboard/Index.vue'
import NotFound from './components/modules/dashboard/404.vue'
import WidgetsIndex from './components/modules/widgets/Index.vue'
import UIButtons from './components/modules/ui/Buttons.vue'
import UIGeneral from './components/modules/ui/General.vue'
import UIIcons from './components/modules/ui/Icons.vue'
import UIModals from './components/modules/ui/Modals.vue'
import UISliders from './components/modules/ui/Sliders.vue'
import UITimeline from './components/modules/ui/Timeline.vue'
// Form
import FormRadio from './components/modules/form/FormRadio.vue'
import FormCheckbox from './components/modules/form/FormCheckbox.vue'
import FormInput from './components/modules/form/FormInput.vue'
import FormSelect from './components/modules/form/FormSelect.vue'
import FormCascader from './components/modules/form/FormCascader.vue'
import FormSwitch from './components/modules/form/FormSwitch.vue'
import VueBar from './components/modules/chart/VueBar.vue'
// import SChart from './components/modules/chart/SChart.vue'
import ChartJs from './components/modules/chart/ChartJs.vue'
import ChartBar from './components/modules/chart/ChartBar.vue'
import ChartPie from './components/modules/chart/ChartPie.vue'
import FormSlider from './components/modules/form/FormSlider.vue'
import FormTimePicker from './components/modules/form/FormTimePicker.vue'
import Mail from './components/modules/Mail.vue'
import DashboardSecond from './components/modules/dashboard/DashboardSecond.vue'
import Chat from './components/modules/Chat.vue'
import Calendar from './components/modules/Calendar.vue'
import ToDo from './components/modules/ToDo.vue'
import BlogList from './components/modules/BlogList.vue'
import BlogDetails from './components/modules/BlogDetails.vue'
import BlogMansory from './components/modules/BlogMansory.vue'
import ShopHome from './components/modules/ShopHome.vue'
import ShopItem from './components/modules/ShopItem.vue'
import BlankPage from './components/modules/common-page/BlankPage.vue'
import InvoicePage from './components/modules/common-page/Invoice.vue'
import Profile from './components/modules/common-page/Profile.vue'
import Login from './components/Login.vue'
import Login1 from './components/modules/login/Login.vue'
import NotFoundSecond from './components/modules/dashboard/500.vue'
import SimpleTable from './components/modules/tables/SimpleTable.vue'
import CobaTable from './components/modules/tables/CobaTable.vue'
import SelectTable from './components/modules/tables/SelectTable.vue'
import ExpandableTable from './components/modules/tables/ExpandableTable.vue'
import Editor from './components/modules/ui/Editor.vue'
import Upload from './components/modules/ui/Upload.vue'
import Gmap from './components/modules/Gmap.vue'
import ChartMap from './components/modules/chart/ChartMap.vue'
import OpenLayer from './components/modules/OpenLayer.vue'

// master data
import Toko from './components/modules/master_data/Toko1.vue'
import TokoJenis from './components/modules/master_data/TokoJenis1.vue'
import TokoAdmin from './components/modules/master_data/TokoAdmin1.vue'
import TokoKacab from './components/modules/master_data/TokoKacab1.vue'
import DeviceToko from './components/modules/master_data/TokoDevice1.vue'
import TokoPegawai from './components/modules/master_data/TokoPegawai1.vue'
import Wilayah from './components/modules/master_data/Wilayah1.vue'
import Region from './components/modules/master_data/Region.vue'
import KepalaRegion from './components/modules/master_data/KepalaRegion1.vue'
import KepalaWilayah from './components/modules/master_data/KepalaWilayah1.vue'
import KepalaArea from './components/modules/master_data/KepalaArea1.vue'
import KepalaCabang from './components/modules/master_data/KepalaCabang1.vue'
import LaporanCoba from './components/modules/master_data/LaporanCoba.vue'
import LaporanTree from './components/modules/master_data/LaporanTree.vue'
import Area from './components/modules/master_data/Area1.vue'
import Cabang from './components/modules/master_data/Cabang1.vue'
import PegawaiLevel from './components/modules/master_data/PegawaiLevel1.vue'
import Pegawai from './components/modules/master_data/Pegawai1.vue'
import PegawaiToko from './components/modules/master_data/PegawaiToko.vue'
import BarangSatuan from './components/modules/master_data/BarangSatuan1.vue'
import BarangKelompok from './components/modules/master_data/BarangKelompok1.vue'
import BarangKelompokItem from './components/modules/master_data/BarangKelompokItem1.vue'
import BarangToko from './components/modules/master_data/BarangToko1.vue'
import Barang from './components/modules/master_data/Barang1.vue'
import BarangKonversi from './components/modules/master_data/BarangKonversi1.vue'
import BarangJadi from './components/modules/master_data/BarangJadi1.vue'
import BarangJadiBahan from './components/modules/master_data/BarangJadiBahan1.vue'
import BarangAccurate from './components/modules/master_data/BarangAccurate.vue'
import Menu from './components/modules/master_data/Menu1.vue'
import MenuKategori from './components/modules/master_data/MenuKategori1.vue'
import MenuIngredient from './components/modules/master_data/MenuIngredient1.vue'
import MenuToko from './components/modules/master_data/MenuToko1.vue'
import MenuHarga from './components/modules/master_data/MenuHarga.vue'
import StokPesan from './components/modules/master_data/StokPesan.vue'
import SalesInv from './components/modules/master_data/SalesInv.vue'
import PengeluaranBulanan from './components/modules/master_data/PengBulPilihan1.vue'
import PengeluaranBulananCogs from './components/modules/master_data/PengBulCogs1.vue'
import PengeluaranBulananOpr from './components/modules/master_data/PengBulOpr1.vue'
import PengeluaranBulananSum from './components/modules/master_data/PengBulSum1.vue'
import PengeluaranHarian from './components/modules/master_data/PengeluaranHarian1.vue'
import SavingPilihan from './components/modules/master_data/SavingPilihan1.vue'
import Saving from './components/modules/master_data/Saving1.vue'
import SavingBulanan from './components/modules/master_data/SavingBulanan.vue'
import LaporanHarian from './components/modules/master_data/LaporanHarian1.vue'
import Investor from './components/modules/master_data/Investor1.vue'
import InvestorToko from './components/modules/master_data/InvestorToko1.vue'
import PegawaiAbsensi from './components/modules/master_data/PegawaiAbsensi.vue'
import Absensi from './components/modules/master_data/Absensi1.vue'
import PemesananBarang from './components/modules/master_data/PemesananBarang1.vue'
import Penjualan from './components/modules/master_data/Penjualan1.vue'
import PenjualanInput from './components/modules/master_data/PenjualanInput1.vue'
import Pnl from './components/modules/master_data/Pnl1.vue'
import KacabFee from './components/modules/master_data/KacabFee1.vue'
import TokoDashboard from './components/modules/master_data/TokoDashboard1.vue'
import TokoInfaq from './components/modules/master_data/TokoInfaq1.vue'
import TokoTarget from './components/modules/master_data/TokoTarget1.vue'
import TokoPenerimaanBarang from './components/modules/master_data/TokoPenerimaanBarang1.vue'
import CutoffJenis from './components/modules/master_data/CutoffJenis1.vue'
import CutoffDetail from './components/modules/master_data/CutoffDetail1.vue'
import PinjamBarang from './components/modules/master_data/TokoPinjamBarang1.vue'
import Armada from './components/modules/master_data/Armada.vue'
import Pengiriman from './components/modules/master_data/Pengiriman.vue'
import Excel from './components/modules/master_data/Excel.vue'

import Vue from 'vue'
import VueCookie from 'vue-cookie'
import VueRouter from 'vue-router'
Vue.use(VueCookie)
Vue.use(VueRouter)

// Routes
const routes = [
  {
    path: '/',
    component: Dashboard,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      document.body.className += 'skin-dark sidebar-mini'
      next()
      // if (to.matched.some(record => record.meta.requiresAuth)) {
      //   if (Vue.cookie.get('login') === null || Vue.cookie.get('login') === 'false') {
      //     next()
      //   } else {
      //     next()
      //   }
      // } else {
      //   next()
      // }
    },
    activate: function () {
      this.$nextTick(function () {
        // => 'DOM loaded and ready'
        alert('test')
      })
    },
    children: [
      {
        path: '',
        name: 'dashboard',
        component: DashboardEmpty
      }, {
        path: '/login',
        name: 'Login',
        component: Login1
      }, {
        path: '/login1',
        name: 'Login1',
        component: Login
      }, {
        path: '/toko',
        name: 'toko',
        component: Toko
      }, {
        path: '/toko_jenis',
        name: 'Jenis Toko',
        component: TokoJenis
      }, {
        path: '/toko_admin',
        name: 'Admin Toko',
        component: TokoAdmin
      }, {
        path: '/toko_kacab',
        name: 'Kacab Toko',
        component: TokoKacab
      }, {
        path: '/wilayah',
        name: 'wilayah',
        component: Wilayah
      }, {
        path: '/Region',
        name: 'Region',
        component: Region
      }, {
        path: '/kepala_region',
        name: 'Kepala Region',
        component: KepalaRegion
      }, {
        path: '/kepala_wilayah',
        name: 'Kepala Wilayah',
        component: KepalaWilayah
      }, {
        path: '/kepala_area',
        name: 'Kepala Area',
        component: KepalaArea
      }, {
        path: '/kepala_cabang',
        name: 'Kepala Cabang',
        component: KepalaCabang
      }, {
        path: '/laporancoba',
        name: 'Laporan Coba',
        component: LaporanCoba
      }, {
        path: '/laporan_tree',
        name: 'Laporan Tree',
        component: LaporanTree
      }, {
        path: '/area/:kode/:nama',
        name: 'area',
        component: Area
      }, {
        path: '/cabang',
        name: 'cabang',
        component: Cabang
      }, {
        path: '/pegawai_level',
        name: 'Pegawai Level',
        component: PegawaiLevel
      }, {
        path: '/pegawai',
        name: 'Pegawai',
        component: Pegawai
      }, {
        path: '/pegawai_toko/:kode/:nama',
        name: 'Pegawai Toko',
        component: PegawaiToko
      }, {
        path: '/menu_ingredient/:kode/:nama',
        name: 'Menu Ingredient',
        component: MenuIngredient
      }, {
        path: '/barang_konversi/:kode/:nama',
        name: 'Barang Konversi',
        component: BarangKonversi
      }, {
        path: '/barang_kelompok_item/:kode/:nama',
        name: 'Barang Kelompok Item',
        component: BarangKelompokItem
      }, {
        path: '/menu_toko',
        name: 'Menu Toko',
        component: MenuToko
      }, {
        path: '/menu_harga/:kode/:nama',
        name: 'Menu Harga',
        component: MenuHarga
      }, {
        path: '/toko_device',
        name: 'Device Toko',
        component: DeviceToko
      }, {
        path: '/toko_pegawai',
        name: 'Toko Pegawai',
        component: TokoPegawai
      }, {
        path: '/barang_satuan',
        name: 'Barang Satuan',
        component: BarangSatuan
      }, {
        path: '/barang_kelompok',
        name: 'Barang Kelompok',
        component: BarangKelompok
      }, {
        path: '/barang_toko',
        name: 'Barang Toko',
        component: BarangToko
      }, {
        path: '/barang',
        name: 'Barang',
        component: Barang
      }, {
        path: '/barang_jadi',
        name: 'Barang Jadi',
        component: BarangJadi
      }, {
        path: '/barang_jadi_bahan',
        name: 'Barang Jadi Bahan',
        component: BarangJadiBahan
      }, {
        path: '/barang_accurate',
        name: 'Barang Accurate',
        component: BarangAccurate
      }, {
        path: '/menu',
        name: 'Menu',
        component: Menu
      }, {
        path: '/menu_kategori',
        name: 'Menu Kategori',
        component: MenuKategori
      }, {
        path: '/stok_pesan',
        name: 'Stok Pesan',
        component: StokPesan
      }, {
        path: '/pengeluaran_bulanan/:kode/:nama',
        name: 'Invoice',
        component: SalesInv
      }, {
        path: '/pengeluaran_harian',
        name: 'Pengeluaran Harian',
        component: PengeluaranHarian
      }, {
        path: '/pengeluaran_bulanan_pilihan',
        name: 'Pengeluaran Bulanan Pilihan',
        component: PengeluaranBulanan
      }, {
        path: '/pengeluaran_bulanan_cogs',
        name: 'Pengeluaran Bulanan COGS',
        component: PengeluaranBulananCogs
      }, {
        path: '/pengeluaran_bulanan_opr',
        name: 'Pengeluaran Bulanan OPR',
        component: PengeluaranBulananOpr
      }, {
        path: '/pengeluaran_bulanan_sum',
        name: 'Pengeluaran Bulanan Summary',
        component: PengeluaranBulananSum
      }, {
        path: '/saving_pilihan',
        name: 'Saving Pilihan',
        component: SavingPilihan
      }, {
        path: '/saving',
        name: 'Saving',
        component: Saving
      }, {
        path: '/saving_bulanan/:kode/:nama',
        name: 'Saving Bulanan',
        component: SavingBulanan
      }, {
        path: '/laporan_harian',
        name: 'Laporan Harian',
        component: LaporanHarian
      }, {
        path: '/investor',
        name: 'Investor',
        component: Investor
      }, {
        path: '/investor_toko',
        name: 'Investor Toko',
        component: InvestorToko
      }, {
        path: '/absensi',
        name: 'absensi',
        component: Absensi
      }, {
        path: '/pemesanan_barang',
        name: 'Pemesanan Barang',
        component: PemesananBarang
      }, {
        path: '/penjualan',
        name: 'Penjualan',
        component: Penjualan
      }, {
        path: '/penjualan_input',
        name: 'PenjualanInput',
        component: PenjualanInput
      }, {
        path: '/pnl',
        name: 'Pnl',
        component: Pnl
      }, {
        path: '/kacab_fee',
        name: 'Kacab Fee',
        component: KacabFee
      }, {
        path: '/toko_dashboard',
        name: 'Toko Dashboard',
        component: TokoDashboard
      }, {
        path: '/toko_infaq',
        name: 'Toko Infaq',
        component: TokoInfaq
      }, {
        path: '/toko_target',
        name: 'Toko Target',
        component: TokoTarget
      }, {
        path: '/penerimaan_barang',
        name: 'TokoPenerimaan Barang',
        component: TokoPenerimaanBarang
      }, {
        path: '/pegawai_absensi/:kode/:nama',
        name: 'Pegawai Absensi',
        component: PegawaiAbsensi
      }, {
        path: '/cutoff_jenis',
        name: 'Cutoff Jenis',
        component: CutoffJenis
      }, {
        path: '/cutoff_detail',
        name: 'Cutoff Detail',
        component: CutoffDetail
      }, {
        path: '/toko_pinjam_barang',
        name: 'Pinjam Barang',
        component: PinjamBarang
      }, {
        path: '/armada',
        name: 'Armada',
        component: Armada
      }, {
        path: '/pengiriman',
        name: 'Pengiriman',
        component: Pengiriman
      }, {
        path: '/excel',
        name: 'Excel',
        component: Excel
      }, {
        path: '/dashboard',
        name: 'dashboard-first',
        component: DashboardIndex
      }, {
        path: '/dashboard-second',
        name: 'dashboard-second',
        component: DashboardSecond
      }, {
        path: '/chat',
        name: 'chat',
        component: Chat
      }, {
        path: '/calendar',
        name: 'calendar',
        component: Calendar
      }, {
        path: '/todo',
        name: 'todo',
        component: ToDo
      }, {
        path: '/blog-list',
        name: 'blog-list',
        component: BlogList
      }, {
        path: '/blog-details',
        name: 'blog-details',
        component: BlogDetails
      }, {
        path: '/blog-mansory',
        name: 'blog-mansory',
        component: BlogMansory
      }, {
        path: '/shop-home',
        name: 'shop-home',
        component: ShopHome
      }, {
        path: '/shop-item',
        name: 'shop-item',
        component: ShopItem
      }, {
        path: '/invoice',
        name: 'invoice',
        component: InvoicePage
      }, {
        path: '/widgets',
        name: 'widgets',
        component: WidgetsIndex
      }, {
        path: '/mail',
        name: 'mail',
        component: Mail
      }, {
        path: '/blank-page',
        name: 'blank-page',
        component: BlankPage
      }, {
        path: '/profile',
        name: 'profile',
        component: Profile
      }, {
        path: '/404',
        name: '404-eror',
        component: NotFound
      }, {
        path: '/500',
        name: '500',
        component: NotFoundSecond
      }, {
        path: '/simple-table',
        name: 'simple-table',
        component: SimpleTable
      }, {
        path: '/coba-table',
        name: 'coba-table',
        component: CobaTable
      }, {
        path: '/select-table',
        name: 'select-table',
        component: SelectTable
      }, {
        path: '/expandable-table',
        name: 'expandable-table',
        component: ExpandableTable
      }, {
        path: '/ui/buttons',
        name: 'ui-buttons',
        component: UIButtons
      }, {
        path: '/ui/ui-editor',
        name: 'ui-editor',
        component: Editor
      }, {
        path: '/ui/general',
        name: 'ui-general',
        component: UIGeneral
      }, {
        path: '/ui/icons',
        name: 'ui-icons',
        component: UIIcons
      }, {
        path: '/ui/modals',
        name: 'ui-modals',
        component: UIModals
      }, {
        path: '/ui/sliders',
        name: 'ui-sliders',
        component: UISliders
      }, {
        path: '/ui/timeline',
        name: 'ui-timeline',
        component: UITimeline
      }, {
        path: '/form/radio',
        name: 'form-radio',
        component: FormRadio
      }, {
        path: '/form/checkbox',
        name: 'form-checkbox',
        component: FormCheckbox
      }, {
        path: '/form/input',
        name: 'form-input',
        component: FormInput
      }, {
        path: '/form/select',
        name: 'form-select',
        component: FormSelect
      }, {
        path: '/ui/ui-upload',
        name: 'ui-upload',
        component: Upload
      }, {
        path: '/form/cascader',
        name: 'form-cascader',
        component: FormCascader
      }, {
        path: '/chart-pie',
        name: 'chart-pie',
        component: ChartPie
      },
      {
        path: '/form/switch',
        name: 'form-switch',
        component: FormSwitch
      },
      {
        path: '/form/slider',
        name: 'form-slider',
        component: FormSlider
      },
      {
        path: '/form/timepicker',
        name: 'form-timepicker',
        component: FormTimePicker
      },
      {
        path: '/chart/vuebar',
        name: 'chart-vuebar',
        component: VueBar
      },
      {
        path: '/chart/chartjs',
        name: 'chartjs',
        component: ChartJs
      },
      // {
      //   path: '/chart/schart',
      //   name: 'schart',
      //   component: SChart
      // },
      {
        path: '/chart-bar',
        name: 'chart-bar',
        component: ChartBar
      },
      {
        path: '/gmap',
        name: 'gmap',
        component: Gmap
      }, {
        path: '/open-layer',
        name: 'open-layer',
        component: OpenLayer
      }, {
        path: '/chart/chart-map',
        name: 'chart-map',
        component: ChartMap
      },
      {
        path: '*',
        name: '404',
        component: NotFound
      }
    ]
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js